// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aTcr","top":"styles_top__3hv1B","left":"styles_left__2F3HW","description":"styles_description__1kXcd"};